<template>
  <div class="layer-popup smooth-shadow" v-click-outside="closeDropDown">
    <div class="flex-col">
      <div v-if="!showEntities" class="flex-col">
        <div class="header">
          <h3 class="pad-left-10">Create new layer</h3>
          <expand />
          <i class="material-icons md-18 icon-button" @click="closeDropDown"
            >clear</i
          >
        </div>
        <ul class="popup-options">
          <li @click="showEntities = true">
            <Icon>device_hub</Icon>New Entity Layer
            <expand />
            <Icon>keyboard_arrow_right</Icon>
          </li>
          <li @click="addComputed()">
            <Icon>functions</Icon>New Computed Metric Layer
          </li>
          <li><Icon>open_in_browser</Icon>Import Layers</li>
        </ul>
      </div>

      <div v-else class="flex-col">
        <div class="header">
          <i
            class="material-icons md-18 icon-button"
            @click="showEntities = false"
            >arrow_back</i
          >
          <h3>Choose an Entity</h3>
          <expand />
          <i class="material-icons md-18 icon-button" @click="closeDropDown"
            >clear</i
          >
        </div>
        <LoadingBar v-if="showLoading" />
        <ul v-if="getEntities && !showLoading" class="entity-options">
          <li
            v-for="entity in getEntities"
            :key="entity.id"
            @click="addModel(entity)"
          >
            <h4 class="ellipsis">{{ entity.name }}</h4>
            <p class="ellipsis">{{ entity.description }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EntityModelLayer, ComputedLayer } from "@/models/Layers.model";

export default {
  data() {
    return {
      layerName: "",
      showEntities: false,
      showLoading: false,
    };
  },
  computed: {
    ...mapGetters("Entities", ["getEntities"]),
  },
  methods: {
    ...mapActions("Entities", ["fetchEntities"]),
    ...mapActions("LayerManager", ["addEntityModel", "addComputedProp"]),
    ...mapActions("Popup", ["toggleComputedPropertyCreationPopup"]),
    closeDropDown() {
      this.$emit("close");
    },
    addModel(entity) {
      const model = new EntityModelLayer({
        name: entity.name,
        entity_id: entity.id,
        entity_name: entity.name,
        entity_type: entity.entity_type,
      });
      this.addEntityModel(model);
      this.closeDropDown();
    },
    addComputed() {
      // const computedLayer = new ComputedLayer({
      //   name: 'Untitled layer'
      // });
      // this.addComputedProp(computedLayer);
      this.toggleComputedPropertyCreationPopup();
    },
  },
  mounted() {
    if (!this.getEntities || this.getEntities.length === 0) {
      this.showLoading = true;
      this.fetchEntities()
        .then(() => {
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.layer-popup {
  width: 330px;
  max-width: 330px;
  height: auto;
  background: var(--color-secondary);
  border-radius: 5px;
  position: absolute;
  border: 1px solid var(--border-color);
  left: 0px;
  bottom: 60px;

  .popup-options {
    display: flex;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0;
      padding: 15px 5px 15px 15px;
      width: auto;
      border-bottom: 1px solid var(--border-color);
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
      }

      &:first-child {
        border-radius: 0;
      }
      &:last-child {
        border: 0;
        border-radius: 0 0 5px 5px;
      }

      &:hover {
        background: var(--color-primary-light);
        color: var(--color-primary);
        cursor: pointer;
      }
    }
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 10px 10px 5px;
    border-bottom: 1px solid var(--border-color);

    h3 {
      font-size: 1.1em;
    }
  }

  .entity-options {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      margin: 0;
      padding: 15px 15px 15px 20px;
      border-bottom: 1px solid var(--border-color);

      h4 {
        margin: 0;
        padding: 0;
        font-weight: bold;
      }

      p {
        padding: 5px 0 0 0;
        margin: 0;
        opacity: 0.7;
      }

      &:first-child {
        border-radius: 0;
      }
      &:last-child {
        border: 0;
        border-radius: 0 0 5px 5px;
      }

      &:hover {
        background: var(--color-primary-light);
        cursor: pointer;

        h4,
        p {
          color: var(--color-primary);
        }
      }
    }
  }

  &:after {
    position: absolute;
    content: "";
    bottom: 10px;
    left: 50px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: var(--color-secondary);
    border-bottom: 0;
    margin-left: -20px;
    margin-bottom: -20px;
  }
}
</style>
